<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card" style="width: calc(70% - 2em)">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("import api") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>{{ $t("name") }}</th>
              <th>{{ $t("options") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="mdle in available_apis.remote" :key="mdle">
              <td>
                <div class="title is-5">{{ $t(mdle.name) }}</div>
                <div class="subtitle is-6">{{ mdle.version }}</div>
              </td>
              <td>
                <!-- <div class="button is-rounded" v-if="mdle.local_api">
                  <span class="icon has-text-info"
                    ><i class="fa fa-check"></i
                  ></span>
                </div> -->
                <div
                  class="button is-rounded"
                  v-if="
                    mdle.local_api && mdle.local_api.version == mdle.version
                  "
                >
                  <span class="icon has-text-success"
                    ><i class="fa fa-check has-text-success"></i
                  ></span>
                  <span class="pl-2">{{ $t("updated") }}</span>
                </div>

                <div
                  class="button is-rounded"
                  v-if="
                    mdle.local_api && mdle.local_api.version != mdle.version
                  "
                >
                  <span class="icon has-text-warning"
                    ><i class="fa fa-warning has-text-warning"></i
                  ></span>
                  <span class="pl-2"
                    >{{ $t("different version") }} ({{
                      mdle.local_api.version
                    }})</span
                  >
                </div>

                <button
                  class="button is-rounded is-primary"
                  @click="import_api(mdle)"
                  v-if="
                    !mdle.local_api ||
                    (mdle.local_api && mdle.local_api.version != mdle.version)
                  "
                >
                  <span class="icon"><i class="fa fa-download"></i></span>
                  <span>{{ $t("import") }}</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <p class="buttons">
          <button class="button is-rounded is-danger" @click="close_modal">
            <span class="icon"><i class="fa fa-close"></i></span>
            <span>{{ $t("close") }}</span>
          </button>
        </p>
      </footer>
    </div>
  </div>
</template>
<script>
import { generate_error_message_text, get, success_message } from "@/utils";

export default {
  name: "ImportAPIModal",
  // components: { Permissions },
  data() {
    return {
      is_shown: false,
      available_apis: [],
      meta: {},
      error: "",
    };
  },
  computed: {},
  methods: {
    set_initial_state() {
      this.meta = {
        code_name: "",
      };

      this.error = "";
    },
    close_modal() {
      let v = this;
      v.is_shown = false;
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.is_shown = true;
      v.set_initial_state();
      v.init();
    },
    init() {
      let v = this;
      v.$root.loader(true);
      get("/api/remote", {})
        .then((response) => {
          if (response && response.remote) {
            response.remote = response.remote.map((mdle) => {
              let matching_api = response.local.find((m) => {
                return m.path == mdle.path;
              });
              mdle.local_api = matching_api;
              return mdle;
            });
          }
          v.available_apis = response;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    import_api(mdle) {
      let v = this;
      v.$root.loader(true);
      get("/api/import", { api: mdle.path })
        .then(() => {
          success_message(v.$t("api imported"));
          v.init();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  mounted() {},
};
</script>
<style></style>
